import { p as proxyCustomElement, H, h, c as Host } from './p-0498a6af.js';
import { i as inheritAriaAttributes, n as nanoid, c as clsx } from './p-70e482d1.js';

const stylesCss = ":host{display:inline-block}:host svg{display:block;width:1em;height:1em;fill:currentColor}:host(.size-2xl){font-size:var(--bi-icon-2xl) !important}:host(.size-xl){font-size:var(--bi-icon-xl) !important}:host(.size-large){font-size:var(--bi-icon-large) !important}:host(.size-medium){font-size:var(--bi-icon-medium) !important}:host(.size-small){font-size:var(--bi-icon-small) !important}:host(.color-inherit){color:inherit}:host(.color-primary){color:#01417b}:host(.color-gray){color:#1c1b1b}:host(.color-black){color:var(--bi-basic-key)}:host(.color-white){color:var(--bi-basic-white)}";
const BiIconClockStyle0 = stylesCss;

const BiIconClock$1 = /*@__PURE__*/ proxyCustomElement(class BiIconClock extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.inheritedAttributes = {};
        this.titleText = null;
        /**
         * The color of the icon.
         * @default 'inherit'
         */
        this.color = 'inherit';
    }
    componentWillLoad() {
        this.inheritedAttributes = inheritAriaAttributes(this.el);
        this.titleText = this.el.getAttribute('title');
        if (this.titleText) {
            this.titleId = `title-${nanoid()}`;
        }
    }
    render() {
        return (h(Host, { key: '44d02f62b7e01bd6b70b2c1f933fd3202587d8ea', class: clsx(`color-${this.color}`, this.size && `size-${this.size}`) }, h("svg", { key: 'dc88aeccd2e5c78f753a755e089c7519b54b09a5', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 25 25', focusable: 'false', role: 'img', width: '1em', height: '1em', fill: 'currentColor', "aria-labelledby": this.titleId, ...this.inheritedAttributes }, this.titleText ? h("title", { id: this.titleId }, this.titleText) : null, h("path", { key: 'e4565876072ff0d727e40a1ffd485223ae9a3425', "fill-rule": 'evenodd', d: 'M5.413 11.813h.71v1.5h-.71a7.49 7.49 0 0 0 6.7 6.7v-.71h1.5v.71a7.49 7.49 0 0 0 6.701-6.7h-.71v-1.5h.71a7.49 7.49 0 0 0-6.7-6.701v.71h-1.5v-.71a7.49 7.49 0 0 0-6.701 6.7Zm-1.538.75a8.988 8.988 0 1 1 17.976 0 8.988 8.988 0 0 1-17.976 0m8.238-.661V8.818h1.5v3.084c.143.162.234.37.248.598l3.277 3.277-1.06 1.06-3.277-3.276a1 1 0 0 1-.688-1.659', "clip-rule": 'evenodd' }))));
    }
    get el() { return this; }
    static get style() { return BiIconClockStyle0; }
}, [1, "bi-icon-clock", {
        "size": [513],
        "color": [513]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bi-icon-clock"];
    components.forEach(tagName => { switch (tagName) {
        case "bi-icon-clock":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BiIconClock$1);
            }
            break;
    } });
}

const BiIconClock = BiIconClock$1;
const defineCustomElement = defineCustomElement$1;

export { BiIconClock, defineCustomElement };
